import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import React, { Fragment, useCallback, useMemo } from 'react';

import Shape from '../../../common/Shape';
import Loader from '../../../common/Loader';
import ProviderNameAvatar from '../ProviderNameAvatar';
import { sequenceWords } from '../../helpers/stringManipulations';
import {
  fullProviderSubtitle,
  transformProviderNameWithTitle,
} from '../../../../utils/appointments/provider-details-formatter';

import styles from './styles.styl';

function VisitOverview({
  isEirVisitType,
  isInlineVisit,
  loading,
  openLocationModal,
  organization,
  provider,
  renderAvatar,
  renderBtn,
  renderHeader,
  rows,
  visitName,
  withTopPositionDefault,
}) {
  const renderProviderSubTitle = useCallback(fullProviderSubtitle, []);

  const providerDetails = useMemo(
    () => transformProviderNameWithTitle(provider),
    [provider],
  );

  function renderAvatarSection() {
    if (typeof renderAvatar === 'function') {
      return renderAvatar();
    }

    if (isInlineVisit || isEirVisitType) {
      if (isEmpty(provider)) {
        return (
          <div className={styles.inlineVisit}>
            <img
              style={{ width: 40 }}
              src={organization.logo.thumbMin}
              alt="organization-logo"
            />
            <div>
              <p>{organization.name}</p>
              <p>{visitName}</p>
            </div>
          </div>
        );
      }

      return (
        <div className={styles.inlineVisit}>
          <img
            style={{ width: 40 }}
            src={provider.avatar.thumbMin}
            alt="provider-logo"
          />
          <div>
            <p>{provider.pwbDisplayableName}</p>
            <p>{sequenceWords([provider.specialization, organization.name])}</p>
          </div>
        </div>
      );
    }

    return (
      <ProviderNameAvatar
        renderMeta={renderProviderSubTitle}
        provider={providerDetails}
        avatarSize={44}
      />
    );
  }

  const openModalHandle = () => {
    openLocationModal(true);
  };

  return (
    <Fragment>
      <Shape styleName="OverviewHeader" withoutMargin>
        {renderAvatarSection()}
        {renderHeader()}
      </Shape>
      <Shape
        styleName={cn('Overview', {
          'Overview--topPosition': withTopPositionDefault,
        })}
      >
        <div styleName={cn({ loading })}>
          {loading && <Loader styleName="loader" />}
          {rows.map(({ row, id }) => (
            <div styleName="OverviewRow" key={id}>
              {row.map(
                (
                  {
                    title,
                    text,
                    extra,
                    location,
                    icsUrl,
                    icsUrlTitle,
                    component,
                    fullWidthRow,
                    style,
                  },
                  index,
                ) => {
                  return (
                    (fullWidthRow && (
                      // eslint-disable-next-line react/no-array-index-key
                      <div className={styles.fullWidthRow} key={index}>
                        {component}
                      </div>
                    )) || (
                      <div styleName="OverviewCell" key={title}>
                        {component || (
                          <Fragment>
                            <div styleName="OverviewCell-title">{title}</div>
                            <div styleName="OverviewCell-text" style={style}>
                              {text}
                            </div>
                            {extra && (
                              <div styleName="OverviewCell-extra">{extra}</div>
                            )}
                            {location && (
                              <div
                                styleName="OverviewCell-location"
                                onClick={openModalHandle}
                              >
                                {location}
                              </div>
                            )}
                            {icsUrl && (
                              <a
                                href={icsUrl}
                                download
                                styleName="OverviewCell-location"
                              >
                                {icsUrlTitle}
                              </a>
                            )}
                          </Fragment>
                        )}
                      </div>
                    )
                  );
                },
              )}
            </div>
          ))}
        </div>
        {renderBtn()}
      </Shape>
    </Fragment>
  );
}

VisitOverview.propTypes = {
  isEirVisitType: PropTypes.bool,
  isInlineVisit: PropTypes.bool,
  loading: PropTypes.bool,
  openLocationModal: PropTypes.func,
  organization: PropTypes.object,
  provider: PropTypes.object,
  renderAvatar: PropTypes.func,
  renderBtn: PropTypes.func,
  renderHeader: PropTypes.func,
  rows: PropTypes.array,
  visitName: PropTypes.string,
  withTopPositionDefault: PropTypes.bool,
};

VisitOverview.defaultProps = {
  isEirVisitType: false,
  openLocationModal: () => {},
  renderBtn: () => {},
  renderHeader: () => {},
  rows: [],
};

export default CSSModules(VisitOverview, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/VisitOverview/index.jsx